import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from '../core/services/employee.service';
import { environment } from '../../environments/environment';
import { RequestTrainingService } from '../core/services/request-training.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  header: string = 'Employee Services';
  isStrategicMode: boolean = false;
  isAdminOfStrategicProject: boolean = false;
  isHRAdmin = false;
  hrAdminRole = 'HRAdmin';
  isProd = environment.production

  constructor(
    private router: Router,
    private employeeService: EmployeeService,
    private requestTrainingService: RequestTrainingService,
  ) {
  }

  ngOnInit(): void {
    const route = this.router.url;
    if (route.includes('strategic-plan')) {
      this.header = 'Strategic plans & Milestone tracking';
      this.isStrategicMode = true;
      this.checkUserRoleOfStrategicProject();
    }
    this.onChange();
  }

  onChange() {
    this.requestTrainingService.getUserRole().toPromise()
      .then(res => {
        this.isHRAdmin = res.some(role => role.role === this.hrAdminRole);
      })
      .catch(err => {
        this.isHRAdmin = false;
      })
  }

  checkUserRoleOfStrategicProject() {
    this.employeeService.me().toPromise()
    .then(res => {
      if (res.deptRelation.deptID === '100046' || res.deptRelation.deptID === '100314') {
        this.isAdminOfStrategicProject = true;
      }
    })
    .catch(err => {
      console.log('err',err);
    })
  }

  onRouteToStrategicPlan() {
    const path = 'https://setth.sharepoint.com/sites/intranet/Lists/SPKPI/AllItems.aspx';
    window.open(path, '_blank')
  }

}
